module.exports = __webpack_public_path__ + "static/media/2.25696bae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/2.jpg
// module id = 590
// module chunks = 0